<template>
	<svg
		:class="{
			'_om_inbox-icon-solid': true === solid,
			'_om_inbox-icon-hover-fill': 'hover' === solid,
		}"
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M21.3333 0.5H2.66667C1.2 0.5 0 1.7 0 3.16667V21.8333C0 23.3 1.18667 24.5 2.66667 24.5H21.3333C22.8 24.5 24 23.3 24 21.8333V3.16667C24 1.7 22.8 0.5 21.3333 0.5ZM21.3331 21.8329H2.66646V17.8329H7.41313C8.33313 19.4196 10.0398 20.4996 12.0131 20.4996C13.9865 20.4996 15.6798 19.4196 16.6131 17.8329H21.3331V21.8329ZM14.6798 15.1664H21.3331V3.1664H2.66646V15.1664H9.34646C9.34646 16.6331 10.5465 17.8331 12.0131 17.8331C13.4798 17.8331 14.6798 16.6331 14.6798 15.1664Z"
			fill="currentColor"
		/>
		<g v-if="solid" class="_om_inbox-icon-fill" transform="matrix(1,0,0,1,0,0.371529)">
			<path
				d="M14.599,16.8L22,16.8L22,22.8L2,22.8L2,16.8L9.495,16.8C9.974,17.721 10.938,18.35 12.047,18.35C13.156,18.35 14.119,17.721 14.599,16.8Z"
				fill="currentColor"
			/>
		</g>
	</svg>
</template>
<script lang="js">
export default {
	props : {
		solid : [Boolean, String],
	}
}
</script>
<style scoped>
._om_inbox-icon-fill {
	display: none;
}
._om_inbox-icon-solid ._om_inbox-icon-fill,
._om_inbox-icon-hover-fill:hover ._om_inbox-icon-fill {
	display: block;
}
</style>
